import { ActiveTab } from '@/constants/chat'
import { ChatState } from '@/redux/types/chat'

export const initialState: ChatState = {
  activeChatMessages: [],
  advisorChatMessages: [],
  negotiationChatMessages: [],
  input: '',
  activeAdvisor: [],
  activeProfessor: false,
  activeTab: ActiveTab.Advisor,
  isGenerating: false,
  loadingAdvisorMsgs: false,
  negotiationDrafts: {},
  advisorDraft: '',
  advisorChatHasMore: false,
  advisorChatCurrentPage: 1,
  advisorChatTotalCount: 0,
  advisorChatLoadingMore: false,
  advisorUnreadCount: 0,
  resourceLimits: undefined,
}
